import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { canActivate } from '../../../utils/utility';
import './commonTab.less';
import { Col, Row } from 'antd';
import './NestedRoute.less';

const NestedRoute = ({
  match,
  defaultPage,
  nestedNav,
  commonComponent: CommonComponent,
  tabType,
  rightComponent: RightComponent,
  isWidthFull = false,
  centerId,
  isGrpLogin,
  // tslint:disable-next-line:trailing-comma
  ...args
}: any): ReactElement => {
  return (
    <React.Fragment>
      <Row className={isWidthFull ? `navbar-container w-100 ${(isGrpLogin && !centerId)
        ? 'margin-top12' : ''}` : 'navbar-container'}>
        <Col className={isWidthFull ? 'w-100' : ''}>
          {CommonComponent ? (
            <CommonComponent
              match={match}
              defaultPage={defaultPage}
              nestedNav={nestedNav}
              tabType={tabType}
            />
          ) : null}
        </Col>
        <Col>{RightComponent ? <RightComponent {...args} /> : null}</Col>
      </Row>
      <Switch>
          {nestedNav
            .filter(({ accessCheckKeyword }: any): boolean =>
              canActivate(accessCheckKeyword),
            )
            .map(({ routeName, Component }: any): any => {
              return (
                <Route
                  path={`${match.path}/${routeName === '/' ? '' : routeName}`}
                  component={Component}
                  key={routeName}
                />
              );
            })}
          <Route exact={true} path="*">
            <Redirect from="*" to={`${match.path}/${defaultPage}`} />
          </Route>
        </Switch>
    </React.Fragment>
  );
};

export default NestedRoute;
